import { useState } from 'react';

const mediaItems = [
  {
    id: 1,
    title: '《流浪地球3》重磅来袭',
    desc: '国产科幻巨制续作，视觉效果再升级',
    views: '128万',
    tags: ['科幻', '国产', '热门'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20visual%20with%20dramatic%20space%20elements%2C%20warm%20cosmic%20lighting%2C%20futuristic%20atmosphere%2C%20coral%20and%20amber%20color%20scheme%2C%20cinematic%20style%2C%20minimal%20clean%20design&width=640&height=400&seq=md-01-2026&orientation=landscape',
  },
  {
    id: 2,
    title: '《繁城之下》悬疑剧场',
    desc: '古装悬疑探案，层层反转烧脑不断',
    views: '96万',
    tags: ['悬疑', '古装', '热播'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20ancient%20Chinese%20drama%20visual%20with%20atmospheric%20warm%20lantern%20lighting%2C%20traditional%20elements%2C%20deep%20amber%20and%20burgundy%20tones%2C%20cinematic%20mood%2C%20clean%20minimal%20style&width=640&height=400&seq=md-02-2026&orientation=landscape',
  },
  {
    id: 3,
    title: '《海洋深处》纪录探索',
    desc: '潜入深海，揭开未知世界的面纱',
    views: '73万',
    tags: ['纪录', '探索', '4K'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Deep%20ocean%20documentary%20visual%20with%20ethereal%20underwater%20warm%20lighting%2C%20marine%20elements%2C%20soft%20teal%20and%20coral%20tones%2C%20cinematic%20style%2C%20minimal%20clean%20composition&width=640&height=400&seq=md-03-2026&orientation=landscape',
  },
  {
    id: 4,
    title: '《欢笑一家人》喜剧热映',
    desc: '合家欢爆笑喜剧，轻松解压首选',
    views: '156万',
    tags: ['喜剧', '家庭', '热门'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20bright%20family%20comedy%20visual%20with%20cheerful%20sunlight%2C%20happy%20atmosphere%2C%20soft%20golden%20and%20peach%20tones%2C%20cinematic%20family%20scene%2C%20minimal%20modern%20style&width=640&height=400&seq=md-04-2026&orientation=landscape',
  },
  {
    id: 5,
    title: '《全職高手》动画回归',
    desc: '电竞题材热血国漫，青春不散场',
    views: '89万',
    tags: ['动漫', '电竞', '更新'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Dynamic%20anime%20esports%20visual%20with%20vibrant%20energy%20effects%2C%20competitive%20gaming%20elements%2C%20warm%20coral%20and%20electric%20amber%20tones%2C%20modern%20animation%20style%2C%20clean%20design&width=640&height=400&seq=md-05-2026&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-12 gap-4">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              热门推荐
            </h2>
            <p className="text-sm md:text-base text-foreground-500">
              精选本周最受欢迎的影视内容
            </p>
          </div>
          <span className="inline-flex items-center gap-1 text-sm text-primary-500 font-medium cursor-pointer hover:text-primary-600 transition-colors">
            查看全部 <i className="ri-arrow-right-line"></i>
          </span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <MediaCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}

function MediaCard({ item }: { item: typeof mediaItems[0] }) {
  const [imgError, setImgError] = useState(false);

  return (
    <div className="group bg-background-100 rounded-xl overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer">
      <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-200">
        {!imgError ? (
          <img
            src={item.imageUrl}
            alt={item.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            onError={() => setImgError(true)}
          />
        ) : null}
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent pointer-events-none"></div>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center">
            <i className="ri-play-fill text-background-50 text-2xl ml-0.5"></i>
          </div>
        </div>
        <div className="absolute top-3 right-3 px-2 py-1 rounded-md bg-black/60 text-background-50 text-xs">
          {item.views}次
        </div>
      </div>
      <div className="p-4">
        <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 line-clamp-1">
          {item.title}
        </h3>
        <p className="text-xs text-foreground-500 mb-3 line-clamp-1">{item.desc}</p>
        <div className="flex flex-wrap gap-1.5">
          {item.tags.map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-600 text-xs font-medium"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}